import { render, staticRenderFns } from "./CompletedFinalReview.vue?vue&type=template&id=6a024a59&scoped=true"
import script from "./CompletedFinalReview.vue?vue&type=script&lang=js"
export * from "./CompletedFinalReview.vue?vue&type=script&lang=js"
import style0 from "./CompletedFinalReview.vue?vue&type=style&index=0&id=6a024a59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a024a59",
  null
  
)

export default component.exports